import {describeApiOutcome} from '@/utils/apiOutcome';

const GONE = 410;

export const INVITATION_FAILED_FALLBACK = 'Er ging iets mis. Probeer het later opnieuw.';

export function tokenFromPath(pathname) {
    const match = String(pathname || '').match(/^\/uitnodiging\/([^/?#]+)/);

    if (!match) {
        return null;
    }

    try {
        return decodeURIComponent(match[1]);
    } catch (malformedEscape) {
        return match[1];
    }
}

export function describeInvitationOutcome(result) {
    const outcome = describeApiOutcome(result, {field: 'password'});

    return {
        ...outcome,
        message: outcome.ok ? null : outcome.fieldError || INVITATION_FAILED_FALLBACK,
        isNoLongerValid: outcome.status === GONE,
    };
}
